import React from 'react';
import { BackgroundProps } from './types/LayoutTypes';
import { BackgroundElement } from './styles/LayoutStyles';

export const Background: React.FC<BackgroundProps> = ({ children }) => {
  return (
    <BackgroundElement>
      {children}
    </BackgroundElement>
  );
}; 